import { when } from 'mobx';
import { onFormatViewable } from '../../js/format-utils';
import { MraidStore } from '../MraidStore';
import { AnalyticsStore } from '../AnalyticsStore';
import { IgnorePreloadingStore } from '../preloading/IgnorePreloadingStore';
import { IPreloadingStore } from '../preloading/IPreloadingStore';

interface ImpressionHandlerProps {
  mraidStore: MraidStore;
  analyticsStore: AnalyticsStore;
  formatOptions: FormatOptions;
  preloadingStore?: IPreloadingStore;
  formatName?: FormatName;
}

export class ImpressionHandler {
  mraidStore: MraidStore;
  preloadingStore: IPreloadingStore;
  analyticsStore: AnalyticsStore;
  formatOptions: FormatOptions;
  formatName?: FormatName;

  constructor({
    mraidStore,
    preloadingStore = new IgnorePreloadingStore(),
    analyticsStore,
    formatOptions,
    formatName
  }: ImpressionHandlerProps) {
    this.mraidStore = mraidStore;
    this.preloadingStore = preloadingStore;
    this.analyticsStore = analyticsStore;
    this.formatOptions = formatOptions;
    this.formatName = formatName;
    when(
      () => this.mraidStore.isViewable && this.preloadingStore.isPreloaded,
      () => this.handle()
    );
  }

  handle() {
    const formatOptions = this.formatOptions;
    if (formatOptions?.callbacks?.onImpression) {
      formatOptions.callbacks.onImpression();
    }
    this.analyticsStore.sendImpressionFormat();
    this.mraidStore.triggerOnAdImpression();
    onFormatViewable();
  }
}
